import { ItemList } from 'orm'
import { values, get, map, head, filter } from 'lodash'
import { download } from 'actions/lib'
 
class DemographicList extends ItemList {
    getEntityKey() {
        return "admin/demographic"
    }

    getAsOptions() {
        const items = this.getVisibleObjects()
        return map(items, function(item) { return {label: item.company.name,
                                                   value: item.company.id}})
    }

    getForCompany({company_id}) {
        // Assumes the matching beneficiary is already loaded
        return head(filter(values(this.getAllObjects()), (x) => get(x, ["company", "id"]) === company_id))
    }

}

export const adminDemographicList = new DemographicList("admin_demographic__default")